import {loadStripe} from '@stripe/stripe-js'

const state = () => ({
  loading: false,
  stripe: null,
  active: {
    plan: 0,
    period: 0
  },
  plans: [
    {
      name: 'ESTAGE - Pro',
      duration: [
        {
          id: 53,
          code: 'ESTAGE_Pro',
          name: 'ESTAGE Pro - Monthly',
          interval: 'month',
          trial_days: 14,
          price: 197
        },
        {
          id: 54,
          code: 'ESTAGE_Pro_Y',
          name: 'ESTAGE Pro - Annual',
          interval: 'year',
          trial_days: 14,
          price: 1970
        }
      ]
    }
    // {
    //   name: 'ESTAGE - Starter',
    //   duration: [
    //     {
    //       id: 34,
    //       code: 'STARTER_Y',
    //       name: 'Yearly',
    //       interval: 'year',
    //       trial_days: 14,
    //       price: 970
    //     },
    //     {
    //       id: 32,
    //       code: 'STARTER',
    //       name: 'Monthly',
    //       interval: 'month',
    //       trial_days: 14,
    //       price: 97
    //     }
    //   ]
    // },
    // {
    //   name: 'Estage - Business',
    //   duration: [
    //     {
    //       id: 36,
    //       code: 'E_BUSINESS_Y',
    //       name: 'Yearly',
    //       interval: 'year',
    //       trial_days: 14,
    //       price: 2970
    //     },
    //     {
    //       id: 35,
    //       name: 'Monthly',
    //       code: 'E_BUSINESS',
    //       interval: 'month',
    //       trial_days: 14,
    //       price: 297
    //     }
    //   ]
    // },
    // {
    //   name: 'Estage - Agency',
    //   duration: [
    //     {
    //       id: 38,
    //       code: 'AGENCY_Y',
    //       name: 'Yearly',
    //       interval: 'year',
    //       trial_days: 14,
    //       price: 4970
    //     },
    //     {
    //       id: 37,
    //       code: 'AGENCY',
    //       name: 'Monthly',
    //       interval: 'month',
    //       trial_days: 14,
    //       price: 497
    //     }
    //   ]
    // }
  ],
  premiumFeatures: [
    'Unlimited Video Hosting',
    'Real-time CTA',
    'ESTAGE Public Live Streaming',
    'ESTAGE Private Live Streaming',
    'Live Streaming Instant Replays',
    'Community Live Video Posts',
    'ESTAGE Native Live Chat',
    'Community Private Events',
    'Courses - Daily Challenge Mode',
    'Courses - A/R Integration for Lessons',
    'Community - Opportunities',
    'Community - MSI Ecosystem',
    'Community - IPS (Integrated Product Suite) Licensing and Management',
    'Community - Featured Ad Widget (in feed)',
    'Community - Upcoming Events Widget (in feed)',
    'And much, much more!'
  ]
})

const getters = {
  selectedPlan (state) {
    return state.plans[state.active.plan].duration[state.active.period]
  },
  selectedPlanAmount (state) {
    const plan = state.plans[state.active.plan].duration[state.active.period]
    return `$${plan.price}/${plan.interval}`
  }
}

const actions = {
  async initStripe ({state}) {
    const key = process.env.NODE_ENV === 'development'
      ? process.env.VUE_APP_STRIPE_KEY_DEV
      : process.env.VUE_APP_STRIPE_KEY

    state.stripe = await loadStripe(key)
  },
  async showPaymentError (_ctx, err) {
    console.error('Transaction Error', err)
    const msg =
        err.error?.message ||
        err.response?.data?.message ||
        err.response?.data?.errors?.message ||
        err.response?.data?.errors?.email[0] ||
        err.message ||
        'There was an error while processing this transaction. Please try again'

    await this.$swal.fire({
      icon: 'error',
      title: 'Transaction Error',
      text: msg,
      showConfirmButton: false
    })

    return msg
  },
  async confirmCardPayment ({state}, form) {
    try {
      if (!state.stripe) {
        return console.error('Stripe is not initialized')
      }
      if (!form.card) {
        return console.error('Stripe Card Element is missing')
      }

      const { paymentMethod, error } = await state.stripe.createPaymentMethod({
        type: 'card',
        card: form.card,
        billing_details: {
          name: form.cardHolder,
          email: form.email || undefined
        }
      })
      if (error) {
        await this.$swal.fire({
          icon: 'error',
          title: 'Payment Declined.',
          text: error.message,
          showConfirmButton: false
        })
        return false
      }

      return {
        id: undefined,
        payment_method: paymentMethod.id,
        payment_method_id: paymentMethod.id
      }
    } catch (e) {
      console.error(e)
      await this.$swal.fire({
        icon: 'error',
        title: 'Payment Declined.',
        text: e?.message || 'There was an error while creating the payment method.',
        showConfirmButton: false
      })
      return false
    }
  },
  async handleServer3DS ({state, dispatch}, flowResponse) {
    if (flowResponse?.data?.status === 'requires_action' && flowResponse?.data?.client_secret) {
      const next = await state.stripe.handleNextAction({
        clientSecret: flowResponse.data.client_secret
      })
      if (next.error) {
        console.error(next.error)
        await dispatch('showPaymentError', next.error)
        return { ok: false }
      }
      return { ok: true }
    }
    return { ok: true }
  },
  async checkPayment ({state, dispatch}, payload) {
    try {
      state.loading = true

      let method = null
      if (!payload.pm || payload.pm === 'new-method') {
        method = await dispatch('confirmCardPayment', payload.card)
      } else {
        method = {
          payment_method: payload.pm,
          payment_method_id: payload.pm
        }
      }
      if (!method) return { ok: false, error: 'Unable to create payment method' }

      const checkRes = await axios.post(payload.url, {
        ...payload.body,
        [payload.payment_field ? payload.payment_field : 'payment_method']: method.payment_method_id || method.payment_method
      })
        .catch(async (err) => {
          await dispatch('showPaymentError', err)
          return null
        })

      if (!checkRes) return { ok: false }

      if (checkRes.data.status === 'error' && checkRes.status !== 200) {
        await dispatch('showPaymentError', checkRes.data?.error || checkRes.data)
        return { ok: false }
      }

      const response =
          checkRes.data?.data || {}

      if (response.status === 'requires_action' && response.client_secret) {
        const acted = await dispatch('handleServer3DS', { data: response })
        if (!acted.ok) return { ok: false }
        return {
          ok: true,
          requires_finalize: true,
          invoice_id: response.invoice
        }
      }

      if (response.status !== 'requires_action' && response.access_token) {
        return {
          ok: true,
          requires_finalize: true,
          invoice_id: response.invoice_id,
          access_token: response.access_token
        }
      } else if (response.is_active && response.access_token || response.status === 'succeeded') {
        return {
          ok: true,
          requires_finalize: false,
          ...response
        }
      } else if (response.status !== 'requires_action' && response.payment_intent) {
        return {
          ok: true,
          requires_finalize: true,
          invoice_id: response.invoice_id
        }
      }

      await dispatch('showPaymentError', {message: 'Unexpected check response'})
      return { ok: false }
    } catch (err) {
      await dispatch('showPaymentError', err)
      return { ok: false }
    } finally {
      state.loading = false
    }
  },
  async checkUserAccessByTags ({rootState}, payload) {
    let tags = []
    if (payload.length) {
      tags = payload.map(tag => Number(tag))
    }

    const res = await fetch('https://estage.com/api/marketplace/template/check-access', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        user_id: rootState.auth.user.id.toString(),
        tags: tags
      })
    })
      .then(res => res.json())

    return res.access
  },
  async checkCoupon (_, payload) {
    const estageID = '38804'

    const body = {
      project_id: estageID,
      product_id: payload.product,
      coupon: payload.coupon
    }
    
    const {data} = await axios.post('api/user/payment-systems/coupons/search', body)

    return data.data
  },
  async buyProduct ({state, dispatch}, payload) {
    try {
      state.loading = true
      // const testMode = '?jkqkamnq=1'
      const baseUrl = 'api/user/payment-systems/products/buy'
      const url = !payload.subscription
        ? 'api/user/payment-systems/products/buy'
        : 'api/user/payment-systems/products/stripe-buy'

      const check = await dispatch('checkPayment', {
        url,
        body: payload.body,
        card: payload.payment_method,
        pm: payload.pm
      })

      if (!check.ok) {
        await dispatch('showPaymentError', check.error)
        return Promise.reject(check?.error || new Error('Signup failed'))
      }

      if (check.access_token) {
        return check
      }

      return await axios.post(baseUrl, {
        ...payload.body,
        invoice_id: check.invoice_id
      })
    } catch (err) {
      console.error(err)
      return Promise.reject(err)
    } finally {
      state.loading = false
    }
  },
  async signup ({state, dispatch}, payload) {
    try {
      state.loading = true
      // const testMode = '?jkqkamnq=1'
      const url = 'api/auth/signup'

      const check = await dispatch('checkPayment', {
        url,
        body: payload.body,
        card: payload.payment_method,
        pm: payload.pm
      })

      if (!check.ok) {
        await dispatch('showPaymentError', check.error)
        return Promise.reject(check?.error || new Error('Signup failed'))
      }

      if (check.access_token) {
        return check
      }

      return await axios.post(url, {
        ...payload.body,
        invoice_id: check.invoice_id
      })
    } catch (err) {
      console.error(err)
      return Promise.reject(err)
    } finally {
      state.loading = false
    }
  },
  async changePlan ({state, dispatch}, payload) {
    try {
      state.loading = true
      // const testMode = '?jkqkamnq=1'
      const url = 'api/user/payment-systems/change-plan'

      const check = await dispatch('checkPayment', {
        url,
        body: payload.body,
        card: payload.payment_method,
        pm: payload.pm,
        payment_field: 'source'
      })

      if (!check.ok) {
        await dispatch('showPaymentError', check.error)
        return Promise.reject(check?.error || new Error('Change Plan failed'))
      }

      if (check.status === 'succeeded') {
        return check
      }

      return await axios.post(url, {
        ...payload.body,
        invoice_id: check.invoice_id,
        source: check.invoice_id
      })
    } catch (err) {
      console.error(err)
      return Promise.reject(err)
    } finally {
      state.loading = false
    }
  },
  async reactivatePlan ({state, dispatch}, payload) {
    try {
      state.loading = true
      // const testMode = '?jkqkamnq=1'
      const url = 'api/user/payment-systems/change-plan'

      const check = await dispatch('checkPayment', {
        url,
        body: payload.body,
        card: payload.payment_method,
        pm: payload.pm,
        payment_field: 'source'
      })

      if (!check.ok) {
        await dispatch('showPaymentError', check.error)
        return Promise.reject(check?.error || new Error('Change Plan failed'))
      }

      if (check.status === 'succeeded') {
        return check
      }

      return await axios.post(url, {
        ...payload.body,
        invoice_id: check.invoice_id,
        source: check.invoice_id
      })
    } catch (err) {
      console.error(err)
      return Promise.reject(err)
    } finally {
      state.loading = false
    }
  }
}

const mutations = {
  SET_LOADING (state, payload) {
    state.loading = payload
  },
  SET_PLAN (state, payload) {
    state.active.plan = payload
  },
  SET_PERIOD (state, payload) {
    state.active.period = payload
  }
}

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations
}